import {useState} from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import List from "./List";
import Csharp from '../../../ressources/images/Logo_csharp.webp';
import python from '../../../ressources/images/Logo_python.webp';
import java from '../../../ressources/images/Logo_java.webp';
import cpp from '../../../ressources/images/Logo_cpp.webp';
import js from '../../../ressources/images/Logo_js.webp';
import kotlin from '../../../ressources/images/Logo_kotlin.webp';
import swift from '../../../ressources/images/Logo_swift.webp';
import sql from '../../../ressources/images/Logo_sql.webp';
import nosql from '../../../ressources/images/Logo_nosql.svg';
import dart from '../../../ressources/images/Logo_dart.webp';
import performance from '../../../ressources/images/Logo_performance.svg';
import qualite from '../../../ressources/images/Logo_qualite.svg';
import portailcms from '../../../ressources/images/Logo_portails-cms.svg';
import etl from '../../../ressources/images/Logo_etl.svg';
import jira from '../../../ressources/images/Logo_jira.svg';
import modernisation from '../../../ressources/images/Logo_modernisation.svg';
import architecture from '../../../ressources/images/Logo_architecture.svg';
import estimation from '../../../ressources/images/Logo_estimation.svg';
import cicd from '../../../ressources/images/Logo_cicd.svg';
import radlad from '../../../ressources/images/Logo_radlad.svg';

export default function SearchBar() {

    const { t } = useTranslation();
    const cards1 = [
      { id: 1, titre: "C#", texte: "notreoffre_03_card9", image: Csharp },
      { id: 2, titre: "C++", texte: "notreoffre_03_card10", image: cpp },
      { id: 3, titre: "JavaScript", texte: "notreoffre_03_card8", image: js },
      { id: 4, titre: "Java", texte: "notreoffre_03_card6", image: java },
      { id: 5, titre: "Python", texte: "notreoffre_03_card11", image: python },
      { id: 6, titre: "Kotlin", texte: "notreoffre_03_card7", image: kotlin },
      { id: 7, titre: "Swift", texte: "notreoffre_03_card5", image: swift },
      { id: 8, titre: "Dart", texte: "notreoffre_03_card4", image: dart },
      { id: 9, titre: "SQL", texte: "notreoffre_03_card3", image: sql },
      { id: 10, titre: "NoSQL", texte: "notreoffre_03_card2", image: nosql },
    ];

    const cards2 = [
      { id:11, titre: t("notreoffre_03_card_titre_11"), texte: "notreoffre_03_card12", image: estimation },
      { id:12, titre: t("notreoffre_03_card_titre_12"), texte: "notreoffre_03_card13", image: architecture },
      { id:13, titre: t("notreoffre_03_card_titre_13"), texte: "notreoffre_03_card14", image: modernisation },
      { id:14, titre: t("notreoffre_03_card_titre_14"), texte: "notreoffre_03_card15", image: jira},
      { id:15, titre: t("notreoffre_03_card_titre_15"), texte: "notreoffre_03_card16", image: etl},
      { id:16, titre: t("notreoffre_03_card_titre_16"), texte: "notreoffre_03_card17", image: portailcms},
      { id:17, titre: t("notreoffre_03_card_titre_17"), texte: "notreoffre_03_card18", image: qualite},
      { id:18, titre: t("notreoffre_03_card_titre_18"), texte: "notreoffre_03_card19", image: performance},
      { id:19, titre: t("notreoffre_03_card_titre_19"), texte: "notreoffre_03_card20", image: cicd},
      { id:20, titre: t("notreoffre_03_card_titre_20"), texte: "notreoffre_03_card21", image: radlad}
    ];

    const data = [...cards1, ...cards2];
    
    const [inputText, setInputText] = useState("");
    
    const inputHandler = (e) => {
      setInputText(e.target.value.toLowerCase());
    };
    
    return (
          <div className="wrapper flex flex-wrap gap-[15px] w-full">
            <div className="flex w-full justify-start">
          <TextField
            id="outlined-basic"
            label={t("notreoffre_03_search_bar_label")}
            variant="outlined"
            sx={{ width: '35%', alignSelf: 'flex-start' }}
            onChange={inputHandler}
          />
          </div>
          <List data={data} input={inputText} />
        </div>
    );
}